module.exports = __webpack_public_path__ + "ph.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ph.svg
// module id = 756
// module chunks = 0